import React from 'react';
import { Button } from 'antd';

export default props => {
  const { data } = props;
  if (!data.enrollment_code && !data.enrollment_url) return null;
  if (!data.enrollment_code) return null;
  if (
    data.enrollment_code.toLowerCase().indexOf('http') === 0 ||
    data.enrollment_url
  ) {
    return (
      <div className="section ">
        <a style={{ display: 'none' }} id="enrollment" href="/">
          enrollment anchor
        </a>
        <h3 className="sectiontitle">Join the practice</h3>
        <div
          class="wide col"
          style={{ alignItems: 'center', justifyContent: 'center' }}
        >
          <p>Click the button to start online enrollment.</p>
          <br />
          <Button size="large" type="primary" href={data.enrollment_url}>
            Enroll now
          </Button>
        </div>
      </div>
    );
  }
  return (
    <div className="section">
      <a style={{ display: 'none' }} id="enrollment" href="/">
        enrollment anchor
      </a>
      <h3 className="sectiontitle">Join the practice</h3>
      <div className="sectionitem" style={{ flex: 1 }}>
        <div
          className="row"
          style={{ height: '400px' }}
          dangerouslySetInnerHTML={{ __html: data.enrollment_code }}
        />
      </div>
    </div>
  );
};
